import { Component, OnInit, ViewChild } from '@angular/core';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { FormGroup } from '@angular/forms';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';

@Component({
  selector: 'app-employee-activity-points',
  templateUrl: './employee-activity-points.component.html',
  styleUrls: ['./employee-activity-points.component.scss']
})
export class EmployeeActivityPointsComponent implements OnInit {

  LoaderComponent: any = '';
  employeeReportForm: FormGroup;
  @ViewChild('successModal')
  successModal: any;
  @ViewChild('alertModal') alertModal: any;
  responseMessage: any;
  dialog: any;
  displayedColumns: string[] = ['activity', 'points'];
  dataSource: any[] = [];
  dataSource1: any[] = [];
  loginData: any;
  Activity: any;
  Activity1: any;
  isEditModeActivity: { [key: string]: boolean } = {}; 
  isEditModeSubActivity: { [key: string]: boolean } = {};

  constructor(private service: WebRequestService, private loginDataStore: Data) { }

  ngOnInit(): void {
    this.loginDataStore.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
    });
    this.service.getActivityPoints(1).then((response) => {
      this.LoaderComponent = LoaderComponent;
          if (response['statusCode'] === 200) {
            this.LoaderComponent = '';
            this.dataSource = response['result'];
            this.dataSource.forEach(activity => this.isEditModeActivity[activity.ActivityID] = false);
          }
        });
        this.service.getActivityPoints(2).then((response) => {
          this.LoaderComponent = LoaderComponent;
              if (response['statusCode'] === 200) {
                this.LoaderComponent = '';
                this.dataSource1 = response['result'];
                this.dataSource1.forEach(activity => this.isEditModeSubActivity[activity.SubActivityID] = false);
              }
            });
  }
  toggleEditMode(activity: any, type: string): void {
    if (type === 'Activity') {
      this.isEditModeActivity[activity.ActivityID] = !this.isEditModeActivity[activity.ActivityID];
      if (!this.isEditModeActivity[activity.ActivityID]) {
        this.updatePoints(activity, type);
      }
    } else if (type === 'subActivity') {
      this.isEditModeSubActivity[activity.SubActivityID] = !this.isEditModeSubActivity[activity.SubActivityID];
      if (!this.isEditModeSubActivity[activity.SubActivityID]) {
        this.updatePoints(activity, type);
      }
    }
  }
  updatePoints(Activity: any, type) {
    let activityName: string = '';
    if(type =='Activity') {
      this.Activity = {
        "ActivityID": Activity.ActivityID,
        "ActivityTypeId": 1,
        "Points": parseInt(Activity.Points)
      };
      activityName = Activity.ActivityName;
    } else if(type == 'subActivity') {
      this.Activity = {
        "SubActivityID": Activity.SubActivityID,
        "ActivityTypeId": 2,
        "Points": parseInt(Activity.Points)
      };
      activityName = Activity.SubActivityName;
    }
    this.service.updateActivityPoints(this.Activity).then((response) => {
      this.LoaderComponent = LoaderComponent
      if (response['statusCode'] === 200) {
        this.LoaderComponent = '';
        this.responseMessage = `${activityName} Points updated successfully.`;
        this.alertModal.show();
        setTimeout(() => {
          this.alertModal.hide();
        }, 5000);
      } else {
        this.LoaderComponent = '';
        this.responseMessage = `${activityName} Points update failed. ${response['message']}`;
        this.alertModal.show();
        setTimeout(() => {
          this.alertModal.hide();
        }, 5000);
      }
    })
   }

  handleError(response: any) {
    this.LoaderComponent = "";
    this.alertModal(response['message'] || 'An error occurred');
  }
  showModal(message: string) {
    this.responseMessage = message;
    this.alertModal.show(); 
    setTimeout(() => {
      this.alertModal.hide();
    }, 3000);
  }
  restrictInput(event: KeyboardEvent): void { 
    const input = event.target as HTMLInputElement; 
    if (input.value.length >= 3 && !isNaN(Number(event.key))) 
      { 
        event.preventDefault(); 
      }
  }
}
